import { lazy } from "react";
import { FeatureFlagRoute } from "../../_features/featureFlags/routing/FeatureFlagRoute";
import PermissionRoute from "./PermissionRoute";
import { ROUTE_PERMISSIONS } from "./routePermissions";

const Payments = lazy(() => import("../../_features/payments/pages/PaymentPage"));
const Invoice = lazy(() => import("../../_features/invoices/pages/InvoicePage"));
const CreateInvoicePage = lazy(() => import("../../_features/invoices/pages/InvoiceCreatePage"));

export const collectRoutes = [
    {
        path: "/collect/payments", element:
            <FeatureFlagRoute feature="payments">
                <PermissionRoute permission={ROUTE_PERMISSIONS.payments.view} moduleName="Payments"><Payments /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/collect/invoice", element:
            <FeatureFlagRoute feature="invoices">
                <PermissionRoute permission={ROUTE_PERMISSIONS.invoices.view} moduleName="Invoices"><Invoice /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/collect/invoice/create", element:
            <FeatureFlagRoute feature="invoices">
                <PermissionRoute permission={ROUTE_PERMISSIONS.invoices.create} moduleName="Invoices"><CreateInvoicePage /></PermissionRoute>
            </FeatureFlagRoute>
    }
];
